import { Injectable } from '@angular/core';
@Injectable()
export class Company {
    id?: number;
    name: string;
    imageId?: string;
    imageData?: string;
}

